module.exports = __webpack_public_path__ + "components/MapControl/svg/Kościół.svg?f896af9f";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Kościół.svg
// module id = 1947
// module chunks = 0